import { type ReactNode, useCallback, useMemo, useState } from 'react'
import { MergeAccountsContext } from './MergeAccountsContext'
import { type Patient } from '@/types/patient'

type Props = {
  children: ReactNode
}

export function MergeAccountsProvider({ children }: Props) {
  const [selectedPatients, setSelectedPatients] = useState<Array<Patient>>([])
  const [searchValue, setSearchValue] = useState<string>('')
  const [filterDob, setFilterDob] = useState<string>('')

  const addPatients = useCallback((patients: Array<Patient>) => {
    setSelectedPatients((prev) => [...prev, ...patients])
  }, [])

  const removePatients = useCallback((patients: Array<Patient>) => {
    setSelectedPatients((prev) => {
      const updated = prev.filter((p) => !patients.find((r) => r.PatientId === p.PatientId))
      return updated
    })
  }, [])

  const reset = useCallback(() => {
    setSelectedPatients([])
    setSearchValue('')
    setFilterDob('')
  }, [])

  const value = useMemo(
    () => ({
      searchValue,
      setSearchValue,
      filterDob,
      setFilterDob,
      selectedPatients,
      addPatients,
      removePatients,
      reset,
    }),
    [addPatients, removePatients, selectedPatients, searchValue, filterDob, reset],
  )

  return <MergeAccountsContext.Provider value={value}>{children}</MergeAccountsContext.Provider>
}
